import { type TextareaHTMLAttributes, forwardRef } from 'react'
import { cn } from '@/shared/utils/cn'

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-[88px] w-full rounded-lg border border-line bg-panel px-3 py-2 text-sm text-ink placeholder:text-ink-subtle',
        'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/50 focus-visible:border-brand',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-[invalid=true]:border-danger aria-[invalid=true]:focus-visible:ring-danger/40',
        className,
      )}
      {...props}
    />
  ),
)
Textarea.displayName = 'Textarea'
